
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./contexts/CartContext";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import { Suspense } from "react";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CartProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <Navbar />
          <Suspense fallback={<div className="min-h-screen" />}>
            <AppRoutes />
          </Suspense>
          <Footer />
        </BrowserRouter>
      </CartProvider>
    </I18nextProvider>
  );
}

export default App;
